import React from 'react'
import Banner from './Banner'
import Description from './Description'

const index = () => {
  return (
    <div>
      <Banner/>
      <Description/>
    </div>
  )
}

export default index
